module.exports = __webpack_public_path__ + "img/activities-5.d95f1c30.jpg";